import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Hero from './components/Hero';
import Services from './components/TireGallery';
import Footer from './components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import shopImage1 from './components/dükkanresim.jpg';
import shopImage2 from './components/dükkanresim2.jpg';
import companyLogo from './components/sirketlogo.png';
import shopImg1 from './dükkanresimleri/1.jpg';
import shopImg2 from './dükkanresimleri/2.jpg';
import shopImg3 from './dükkanresimleri/3.jpg';
import shopImg5 from './dükkanresimleri/5.jpg';
import logo56 from './components/56logo.png';

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-out-cubic',
      once: true,
      offset: 100,
      delay: 100,
      disable: false, // AOS enabled
    });
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  return (
    <Router>
      <div className="App bg-white">
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
            </>
          } />
          <Route path="/servisler" element={
            <>
              <Services />
            </>
          } />
          <Route path="/neden-biz" element={
            <>
              {/* Navigation */}
              <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg">
                <div className="container mx-auto px-6">
                  <div className="flex justify-between items-center py-0">
                    {/* Logo */}
                    <Link to="/" className="flex items-center" onClick={closeMobileMenu}>
                      <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center p-2">
                        <img src={logo56} alt="N56OTOLASTİK Logo" className="w-full h-full object-contain" />
                      </div>
                    </Link>
                    
                    {/* Desktop Navigation */}
                    <div className="hidden md:flex space-x-6">
                      <Link to="/" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        ANA SAYFA
                      </Link>
                      <Link to="/servisler" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        SERVİSLER
                      </Link>
                      <Link to="/neden-biz" className="transition-all duration-300 font-medium text-lg text-red-600 hover:text-red-600">
                        NEDEN BİZ
                      </Link>
                      <Link to="/markalar" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        MARKALAR
                      </Link>
                      <Link to="/hakkimizda" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        HAKKIMIZDA
                      </Link>
                      <Link to="/iletisim" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        İLETİŞİM
                      </Link>
                    </div>

                    {/* Mobile Navigation Button */}
                    <div className="md:hidden flex items-center">
                      <button 
                        onClick={toggleMobileMenu}
                        className="text-black hover:text-red-600 focus:outline-none transition-colors duration-300"
                      >
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          {isMobileMenuOpen ? (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          ) : (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                          )}
                        </svg>
                      </button>
                    </div>
                  </div>

                  {/* Mobile Navigation Menu */}
                  <div className={`md:hidden transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
                    <div className="py-4 border-t border-gray-200">
                      <div className="flex flex-col space-y-4">
                        <Link 
                          to="/" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          ANA SAYFA
                        </Link>
                        <Link 
                          to="/servisler" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          SERVİSLER
                        </Link>
                        <Link 
                          to="/neden-biz" 
                          className="transition-all duration-300 font-medium text-lg text-red-600 hover:text-red-600 px-4 py-2 rounded-lg bg-red-50"
                          onClick={closeMobileMenu}
                        >
                          NEDEN BİZ
                        </Link>
                        <Link 
                          to="/markalar" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          MARKALAR
                        </Link>
                        <Link 
                          to="/hakkimizda" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          HAKKIMIZDA
                        </Link>
                        <Link 
                          to="/iletisim" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          İLETİŞİM
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>

              {/* Tire Showcase Section */}
              <section className="bg-gray-50 py-16 pt-32">
                <div className="container mx-auto px-6">
                  {/* Header */}
                  <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-6 px-4">
                      Sürüş deneyiminizi geliştirin
                    </h2>
                    <p className="text-lg text-gray-600 mb-8 leading-relaxed max-w-3xl mx-auto">
                      Yola güvenle çıkın. N56OTOLASTİK ile her virajda, her hava koşulunda güvenle ilerleyin. 
                      Aracınıza en uygun lastik çözümleri burada..
                    </p>
                    
                    <div className="flex flex-wrap justify-center gap-8 mb-12">
                      <div className="flex items-center space-x-3">
                        <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                        <span className="text-gray-700 font-medium">Üstün Yol Tutuşu</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                        <span className="text-gray-700 font-medium">Maksimum Güvenlik</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                        <span className="text-gray-700 font-medium">Uzun Ömür</span>
                      </div>
                    </div>

                    <a href="tel:05445625656" className="inline-block bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg">
                      Sürüş keyfinizi artırın
                    </a>
                  </div>

                  {/* Services Gallery */}
                  <div className="space-y-16">
                    {/* Lastik Takımı */}
                    <div className="relative">
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                                                 <div className="relative group">
                           <img 
                             src={shopImg1}
                             alt="Lastik Takımı - Profesyonel Montaj Hizmeti" 
                             className="w-full h-96 object-cover rounded-2xl shadow-2xl group-hover:shadow-3xl transition-all duration-500"
                           />
                         </div>
                        <div className="lg:pl-8">
                          <div className="bg-white rounded-2xl p-8 shadow-lg">
                            <h3 className="text-2xl font-bold text-gray-800 mb-4">Profesyonel Lastik Takımı</h3>
                            <p className="text-gray-600 mb-6 leading-relaxed">
                              Uzman ekibimizle aracınızın lastiklerini güvenli ve hızlı bir şekilde takıyoruz. 
                              Modern ekipmanlarımız sayesinde lastik takımı işlemi kısa sürede ve hasarsız bir şekilde gerçekleştirilir.
                            </p>
                            <ul className="space-y-2 text-gray-600">
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Hasarsız montaj</li>
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Hızlı servis</li>
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Kaliteli işçilik</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Balans Ayarı */}
                    <div className="relative">
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                                                 <div className="lg:order-2 relative group">
                           <img 
                             src={shopImg2}
                             alt="Balans Ayarı - Titreşimsiz Sürüş" 
                             className="w-full h-96 object-cover rounded-2xl shadow-2xl group-hover:shadow-3xl transition-all duration-500"
                           />
                         </div>
                        <div className="lg:order-1 lg:pr-8">
                          <div className="bg-white rounded-2xl p-8 shadow-lg">
                            <h3 className="text-2xl font-bold text-gray-800 mb-4">Lastik Balans Ayarı</h3>
                            <p className="text-gray-600 mb-6 leading-relaxed">
                              Aracınızın titreşimini önlemek ve konforlu sürüş deneyimi yaşamanız için 
                              hassas balans ayarı yapıyoruz. Modern balans makinelerimizle mükemmel sonuç garantiliyoruz.
                            </p>
                            <ul className="space-y-2 text-gray-600">
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Titreşim giderme</li>
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Konforlu sürüş</li>
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Hassas ayar</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Onarım Hizmeti */}
                    <div className="relative">
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                                                 <div className="relative group">
                           <img 
                             src={shopImg3}
                             alt="Onarım Hizmeti - Hızlı Çözüm" 
                             className="w-full h-96 object-cover rounded-2xl shadow-2xl group-hover:shadow-3xl transition-all duration-500"
                           />
                         </div>
                        <div className="lg:pl-8">
                          <div className="bg-white rounded-2xl p-8 shadow-lg">
                            <h3 className="text-2xl font-bold text-gray-800 mb-4">Lastik Onarım Hizmeti</h3>
                            <p className="text-gray-600 mb-6 leading-relaxed">
                              Lastik delinmesi ve küçük hasarlarda hızlı onarım hizmeti sunuyoruz. 
                              Kaliteli malzemeler ve uzman işçilikle lastiklerinizi yeniden kullanılabilir hale getiriyoruz.
                            </p>
                            <ul className="space-y-2 text-gray-600">
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Hızlı onarım</li>
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Kaliteli malzeme</li>
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Uzun ömür</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Satış Servisi */}
                    <div className="relative">
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                                                 <div className="lg:order-2 relative group">
                           <img 
                             src={shopImg5}
                             alt="Satış Servisi - Uygun Fiyat" 
                             className="w-full h-96 object-cover rounded-2xl shadow-2xl group-hover:shadow-3xl transition-all duration-500"
                           />
                         </div>
                        <div className="lg:order-1 lg:pr-8">
                          <div className="bg-white rounded-2xl p-8 shadow-lg">
                            <h3 className="text-2xl font-bold text-gray-800 mb-4">Lastik Satış Hizmeti</h3>
                            <p className="text-gray-600 mb-6 leading-relaxed">
                              Geniş marka yelpazesi ve uygun fiyatlarla lastik satış hizmeti sunuyoruz. 
                              Aracınıza en uygun lastik seçimi için uzman ekibimizden destek alabilirsiniz.
                            </p>
                            <ul className="space-y-2 text-gray-600">
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Geniş marka seçeneği</li>
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Uygun fiyatlar</li>
                              <li className="flex items-center"><span className="text-red-500 mr-2">✓</span> Uzman danışmanlık</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          } />
          <Route path="/markalar" element={
            <>
              {/* Navigation */}
              <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg">
                <div className="container mx-auto px-6">
                  <div className="flex justify-between items-center py-0">
                    {/* Logo */}
                    <Link to="/" className="flex items-center" onClick={closeMobileMenu}>
                      <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center p-2">
                        <img src={logo56} alt="N56OTOLASTİK Logo" className="w-full h-full object-contain" />
                      </div>
                    </Link>
                    
                    {/* Desktop Navigation */}
                    <div className="hidden md:flex space-x-6">
                      <Link to="/" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        ANA SAYFA
                      </Link>
                      <Link to="/servisler" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        SERVİSLER
                      </Link>
                      <Link to="/neden-biz" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        NEDEN BİZ
                      </Link>
                      <Link to="/markalar" className="transition-all duration-300 font-medium text-lg text-red-600 hover:text-red-600">
                        MARKALAR
                      </Link>
                      <Link to="/hakkimizda" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        HAKKIMIZDA
                      </Link>
                      <Link to="/iletisim" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        İLETİŞİM
                      </Link>
                    </div>

                    {/* Mobile Navigation Button */}
                    <div className="md:hidden flex items-center">
                      <button 
                        onClick={toggleMobileMenu}
                        className="text-black hover:text-red-600 focus:outline-none transition-colors duration-300"
                      >
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          {isMobileMenuOpen ? (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          ) : (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                          )}
                        </svg>
                      </button>
                    </div>
                  </div>

                  {/* Mobile Navigation Menu */}
                  <div className={`md:hidden transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
                    <div className="py-4 border-t border-gray-200">
                      <div className="flex flex-col space-y-4">
                        <Link 
                          to="/" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          ANA SAYFA
                        </Link>
                        <Link 
                          to="/servisler" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          SERVİSLER
                        </Link>
                        <Link 
                          to="/neden-biz" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          NEDEN BİZ
                        </Link>
                        <Link 
                          to="/markalar" 
                          className="transition-all duration-300 font-medium text-lg text-red-600 hover:text-red-600 px-4 py-2 rounded-lg bg-red-50"
                          onClick={closeMobileMenu}
                        >
                          MARKALAR
                        </Link>
                        <Link 
                          to="/hakkimizda" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          HAKKIMIZDA
                        </Link>
                        <Link 
                          to="/iletisim" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          İLETİŞİM
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>

              <div className="min-h-screen bg-gray-50 text-black py-16 pt-32">
                <div className="container mx-auto px-6">
                  <div className="text-center mb-16">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-16 px-4" data-aos="fade-up">Markalarımız</h1>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
                      Güvenilir ve kaliteli lastik çözümleri için seçkin markalarla çalışıyoruz
                    </p>
                  </div>

                  {/* Company Logo Section */}
                  <div className="text-center mb-16">
                    <div className="bg-white p-8 rounded-lg shadow-xl max-w-4xl mx-auto">
                      <h3 className="text-xl font-bold text-gray-800 mb-6">Yetkili Bayi</h3>
                      <img 
                        src={companyLogo} 
                        alt="N56OTOLASTİK Şirket Logosu" 
                        className="w-full h-auto max-w-xs mx-auto object-contain mb-8"
                      />
                      <p className="text-gray-600 mb-8">N56OTOLASTİK - Güvenilir Lastik Çözümleri</p>
                      
                      {/* Vehicle Types in Company Logo Section */}
                      <div className="border-t pt-8">
                        <h4 className="text-lg font-semibold text-gray-800 mb-6">Hizmet Verdiğimiz Araç Türleri</h4>
                        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-6">
                          <div className="text-center">
                            <div className="w-12 h-12 mx-auto mb-3 bg-gray-100 rounded-lg shadow-md flex items-center justify-center">
                              <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.22.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
                              </svg>
                            </div>
                            <p className="text-xs font-medium text-gray-700">Binek</p>
                          </div>
                          <div className="text-center">
                            <div className="w-12 h-12 mx-auto mb-3 bg-gray-100 rounded-lg shadow-md flex items-center justify-center">
                              <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M19.15 8c-.13-.65-.66-1.01-1.22-1.01H6.07c-.56 0-1.09.36-1.22 1.01L3 13v7c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-7l-1.85-5zm-12.65 7c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.27-3h11.46L19 10H5z"/>
                              </svg>
                            </div>
                            <p className="text-xs font-medium text-gray-700">SUV</p>
                          </div>
                          <div className="text-center">
                            <div className="w-12 h-12 mx-auto mb-3 bg-gray-100 rounded-lg shadow-md flex items-center justify-center">
                              <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                              </svg>
                            </div>
                            <p className="text-xs font-medium text-gray-700">Hafif Ticari</p>
                          </div>
                          <div className="text-center">
                            <div className="w-12 h-12 mx-auto mb-3 bg-gray-100 rounded-lg shadow-md flex items-center justify-center">
                              <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                              </svg>
                            </div>
                            <p className="text-xs font-medium text-gray-700">Kamyonet</p>
                          </div>
                          <div className="text-center">
                            <div className="w-12 h-12 mx-auto mb-3 bg-gray-100 rounded-lg shadow-md flex items-center justify-center">
                              <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                              </svg>
                            </div>
                            <p className="text-xs font-medium text-gray-700">Kamyon</p>
                          </div>
                          <div className="text-center">
                            <div className="w-12 h-12 mx-auto mb-3 bg-gray-100 rounded-lg shadow-md flex items-center justify-center">
                              <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M17.5 14.5c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5zm-11 0C5.12 14.5 4 15.62 4 17s1.12 2.5 2.5 2.5S9 18.38 9 17s-1.12-2.5-2.5-2.5zm11.5-9H14v4h-2V6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v8.5c0 .55.45 1 1 1h1.5c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1.5c.55 0 1-.45 1-1V8.5c0-.55-.45-1-1-1z"/>
                              </svg>
                            </div>
                            <p className="text-xs font-medium text-gray-700">Zirai</p>
                          </div>
                          <div className="text-center">
                            <div className="w-12 h-12 mx-auto mb-3 bg-gray-100 rounded-lg shadow-md flex items-center justify-center">
                              <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M19.44 9.03L15.41 5H11v2h3.59l2 2H8.97C8.36 8.36 7.7 8 7 8c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H1v2h3.18c-.11.31-.18.65-.18 1 0 1.66 1.34 3 3 3s3-1.34 3-3c0-.35-.07-.69-.18-1h5.36c-.11.31-.18.65-.18 1 0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.66-1.34-3-3-3-.7 0-1.36.36-1.97 1H14l-2-2h7.44L19.44 9.03zM7 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm10 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
                              </svg>
                            </div>
                            <p className="text-xs font-medium text-gray-700">Motorsiklet</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Brands Description */}
                  <div className="text-center">
                    <div className="max-w-4xl mx-auto">
                      <p className="text-lg text-gray-600 leading-relaxed">
                        <strong>Petlas</strong>, <strong>Continental</strong>, <strong>Starmaxx</strong>, <strong>Falken</strong> ve <strong>Milestone</strong> markaları ile çalışarak müşterilerimize 
                        yüksek kaliteli lastik çözümleri sunuyoruz. Bu markalar sektörde güvenilirlik 
                        ve performans açısından öncü konumdadır.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          } />
          <Route path="/hakkimizda" element={
            <>
              {/* Navigation */}
              <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg">
                <div className="container mx-auto px-6">
                  <div className="flex justify-between items-center py-0">
                    {/* Logo */}
                    <Link to="/" className="flex items-center" onClick={closeMobileMenu}>
                      <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center p-2">
                        <img src={logo56} alt="N56OTOLASTİK Logo" className="w-full h-full object-contain" />
                      </div>
                    </Link>
                    
                    {/* Desktop Navigation */}
                    <div className="hidden md:flex space-x-6">
                      <Link to="/" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        ANA SAYFA
                      </Link>
                      <Link to="/servisler" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        SERVİSLER
                      </Link>
                      <Link to="/neden-biz" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        NEDEN BİZ
                      </Link>
                      <Link to="/markalar" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        MARKALAR
                      </Link>
                      <Link to="/hakkimizda" className="transition-all duration-300 font-medium text-lg text-red-600 hover:text-red-600">
                        HAKKIMIZDA
                      </Link>
                      <Link to="/iletisim" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        İLETİŞİM
                      </Link>
                    </div>

                    {/* Mobile Navigation Button */}
                    <div className="md:hidden flex items-center">
                      <button 
                        onClick={toggleMobileMenu}
                        className="text-black hover:text-red-600 focus:outline-none transition-colors duration-300"
                      >
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          {isMobileMenuOpen ? (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          ) : (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                          )}
                        </svg>
                      </button>
                    </div>
                  </div>

                  {/* Mobile Navigation Menu */}
                  <div className={`md:hidden transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
                    <div className="py-4 border-t border-gray-200">
                      <div className="flex flex-col space-y-4">
                        <Link 
                          to="/" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          ANA SAYFA
                        </Link>
                        <Link 
                          to="/servisler" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          SERVİSLER
                        </Link>
                        <Link 
                          to="/neden-biz" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          NEDEN BİZ
                        </Link>
                        <Link 
                          to="/markalar" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          MARKALAR
                        </Link>
                        <Link 
                          to="/hakkimizda" 
                          className="transition-all duration-300 font-medium text-lg text-red-600 hover:text-red-600 px-4 py-2 rounded-lg bg-red-50"
                          onClick={closeMobileMenu}
                        >
                          HAKKIMIZDA
                        </Link>
                        <Link 
                          to="/iletisim" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          İLETİŞİM
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>

              <div className="min-h-screen bg-gray-50 text-black py-16 pt-32">
                <div className="container mx-auto px-4 sm:px-6">
                  <div className="text-center mb-16">
                    <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-8 px-4" data-aos="fade-up">Hakkımızda</h1>
                    <div className="max-w-4xl mx-auto space-y-6 text-gray-600 leading-relaxed">
                      <p data-aos="fade-up" data-aos-delay="200">
                        N56OTOLASTİK, 1967 yılından itibaren lastik sektöründe faaliyet gösteren 
                        köklü bir firmadır. Uzun yıllar boyunca müşterilerimize kaliteli hizmet 
                        sunmayı ilke edinmiş olup, sektördeki deneyimimizle güvenilir bir marka haline gelmiştir.
                      </p>
                      <p data-aos="fade-up" data-aos-delay="400">
                        Şirketimiz, kaliteli lastik çözümleri sunmak amacıyla kurulmuş olup, 
                        yıllar boyunca sektörde kazandığı deneyimle müşterilerine en iyi hizmeti 
                        vermeyi hedeflemektedir.
                      </p>
                      <p data-aos="fade-up" data-aos-delay="600">
                        Günümüzde Petlas, Continental, Starmaxx, Falken ve Milestone markaları ile çalışmakta olan firmamız, 
                        bu güçlü iş birliği sayesinde müşterilerimize geniş bir ürün yelpazesi 
                        sunmaktadır.
                      </p>
                      <p data-aos="fade-up" data-aos-delay="800">
                        Otomobil, 4X4 SUV, Hafif Ticari, Kamyonet, Kamyon-Otobüs, Zirai Grup, 
                        İş Makinaları ve Forklift gruplarında sunduğu satış ve servis 
                        hizmetlerinin yanı sıra lastik oteli, jant, akü gibi 
                        hizmetleri de müşterileriyle buluşturmaktadır.
                      </p>
                    </div>
                  </div>

                  {/* Timeline Section */}
                  <div className="max-w-4xl mx-auto mt-16 px-4">
                    <div className="relative">
                      {/* Timeline Line */}
                      <div className="absolute left-7 md:left-1/2 transform md:-translate-x-1/2 w-0.5 bg-gray-300 h-full"></div>
                      
                      {/* Timeline Items */}
                      <div className="space-y-8 md:space-y-16">
                        
                        {/* N56OTOLASTİK Kuruluş */}
                        <div className="flex items-center relative" data-aos="fade-up">
                          <div className="w-full md:w-1/2 pr-0 md:pr-8 text-left md:text-right pl-12 md:pl-0">
                            <div className="bg-white rounded-lg shadow-lg p-4 md:p-6">
                              <div className="flex items-center space-x-4">
                                <div>
                                  <img 
                                    src={logo56} 
                                    alt="N56OTOLASTİK Logo" 
                                    className="w-16 h-16 object-contain"
                                  />
                                </div>
                                <div>
                                  <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">N56OTOLASTİK Kuruluş</h3>
                                  <p className="text-gray-600 text-sm">1967</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 w-6 h-6 bg-red-600 rounded-full border-4 border-white shadow-lg"></div>
                          <div className="hidden md:block w-1/2 pl-8"></div>
                        </div>

                        {/* Petlas İş Birliği */}
                        <div className="flex items-center relative" data-aos="fade-up" data-aos-delay="200">
                          <div className="hidden md:block w-1/2 pr-8"></div>
                          <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 w-6 h-6 bg-red-600 rounded-full border-4 border-white shadow-lg"></div>
                          <div className="w-full md:w-1/2 pl-12 md:pl-8">
                            <div className="bg-white rounded-lg shadow-lg p-4 md:p-6">
                              <div className="flex items-center space-x-4">
                                <img 
                                  src="https://www.petlas.com/themes/petlas/assets/img/Logo.png" 
                                  alt="Petlas Logo" 
                                  className="w-16 h-16 object-contain"
                                />
                                <div>
                                  <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">Petlas İş Birliği</h3>
                                  <p className="text-gray-600 text-sm">Devam Eden</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Continental İş Birliği */}
                        <div className="flex items-center relative" data-aos="fade-up" data-aos-delay="300">
                          <div className="w-full md:w-1/2 pr-0 md:pr-8 text-left md:text-right pl-12 md:pl-0">
                            <div className="bg-white rounded-lg shadow-lg p-4 md:p-6">
                              <div className="flex items-center space-x-4">
                                <div>
                                  <img 
                                    src="https://www.autoworlddergisi.com/wp-content/uploads/2024/03/1710394911_continental_logo.png" 
                                    alt="Continental Logo" 
                                    className="w-20 h-20 object-contain"
                                  />
                                </div>
                                <div>
                                  <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">Continental İş Birliği</h3>
                                  <p className="text-gray-600 text-sm">Devam Eden</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 w-6 h-6 bg-red-600 rounded-full border-4 border-white shadow-lg"></div>
                          <div className="hidden md:block w-1/2 pl-8"></div>
                        </div>

                        {/* Starmaxx İş Birliği */}
                        <div className="flex items-center relative" data-aos="fade-up" data-aos-delay="400">
                          <div className="hidden md:block w-1/2 pr-8"></div>
                          <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 w-6 h-6 bg-red-600 rounded-full border-4 border-white shadow-lg"></div>
                          <div className="w-full md:w-1/2 pl-12 md:pl-8">
                            <div className="bg-white rounded-lg shadow-lg p-4 md:p-6">
                              <div className="flex items-center space-x-4">
                                <img 
                                  src="https://www.starmaxx.com.tr/Assets/img/sticklogo.png" 
                                  alt="Starmaxx Logo" 
                                  className="w-16 h-16 object-contain"
                                />
                                <div>
                                  <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">Starmaxx İş Birliği</h3>
                                  <p className="text-gray-600 text-sm">Devam Eden</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Falken İş Birliği */}
                        <div className="flex items-center relative" data-aos="fade-up" data-aos-delay="500">
                          <div className="w-full md:w-1/2 pr-0 md:pr-8 text-left md:text-right pl-12 md:pl-0">
                            <div className="bg-white rounded-lg shadow-lg p-4 md:p-6">
                              <div className="flex items-center space-x-4">
                                <div>
                                  <img 
                                    src="https://upload.wikimedia.org/wikipedia/commons/1/1e/FALKEN_Logo_Blue.png" 
                                    alt="Falken Logo" 
                                    className="w-16 h-16 object-contain"
                                  />
                                </div>
                                <div>
                                  <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">Falken İş Birliği</h3>
                                  <p className="text-gray-600 text-sm">Devam Eden</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 w-6 h-6 bg-red-600 rounded-full border-4 border-white shadow-lg"></div>
                          <div className="hidden md:block w-1/2 pl-8"></div>
                        </div>

                        {/* Milestone İş Birliği */}
                        <div className="flex items-center relative" data-aos="fade-up" data-aos-delay="600">
                          <div className="hidden md:block w-1/2 pr-8"></div>
                          <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 w-6 h-6 bg-red-600 rounded-full border-4 border-white shadow-lg"></div>
                          <div className="w-full md:w-1/2 pl-12 md:pl-8">
                            <div className="bg-white rounded-lg shadow-lg p-4 md:p-6">
                              <div className="flex items-center space-x-4">
                                <img 
                                  src="https://files.sikayetvar.com/lg/cmp/32/32395.png?1522650125" 
                                  alt="Milestone Logo" 
                                  className="w-16 h-16 object-contain"
                                />
                                <div>
                                  <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">Milestone İş Birliği</h3>
                                  <p className="text-gray-600 text-sm">Devam Eden</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Günümüz */}
                        <div className="flex items-center relative" data-aos="fade-up" data-aos-delay="700">
                          <div className="w-full md:w-1/2 pr-0 md:pr-8 text-left md:text-right pl-12 md:pl-0">
                            <div className="bg-white rounded-lg shadow-lg p-4 md:p-6">
                              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">Günümüz</h3>
                              <p className="text-gray-600 text-sm">2024</p>
                            </div>
                          </div>
                          <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 w-6 h-6 bg-red-600 rounded-full border-4 border-white shadow-lg"></div>
                          <div className="hidden md:block w-1/2 pl-8"></div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          } />
          <Route path="/iletisim" element={
            <>
              {/* Navigation */}
              <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg">
                <div className="container mx-auto px-6">
                  <div className="flex justify-between items-center py-0">
                    {/* Logo */}
                    <Link to="/" className="flex items-center" onClick={closeMobileMenu}>
                      <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center p-2">
                        <img src={logo56} alt="N56OTOLASTİK Logo" className="w-full h-full object-contain" />
                      </div>
                    </Link>
                    
                    {/* Desktop Navigation */}
                    <div className="hidden md:flex space-x-6">
                      <Link to="/" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        ANA SAYFA
                      </Link>
                      <Link to="/servisler" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        SERVİSLER
                      </Link>
                      <Link to="/neden-biz" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        NEDEN BİZ
                      </Link>
                      <Link to="/markalar" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        MARKALAR
                      </Link>
                      <Link to="/hakkimizda" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                        HAKKIMIZDA
                      </Link>
                      <Link to="/iletisim" className="transition-all duration-300 font-medium text-lg text-red-600 hover:text-red-600">
                        İLETİŞİM
                      </Link>
                    </div>

                    {/* Mobile Navigation Button */}
                    <div className="md:hidden flex items-center">
                      <button 
                        onClick={toggleMobileMenu}
                        className="text-black hover:text-red-600 focus:outline-none transition-colors duration-300"
                      >
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          {isMobileMenuOpen ? (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          ) : (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                          )}
                        </svg>
                      </button>
                    </div>
                  </div>

                  {/* Mobile Navigation Menu */}
                  <div className={`md:hidden transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
                    <div className="py-4 border-t border-gray-200">
                      <div className="flex flex-col space-y-4">
                        <Link 
                          to="/" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          ANA SAYFA
                        </Link>
                        <Link 
                          to="/servisler" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          SERVİSLER
                        </Link>
                        <Link 
                          to="/neden-biz" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          NEDEN BİZ
                        </Link>
                        <Link 
                          to="/markalar" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          MARKALAR
                        </Link>
                        <Link 
                          to="/hakkimizda" 
                          className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600 px-4 py-2 rounded-lg hover:bg-gray-50"
                          onClick={closeMobileMenu}
                        >
                          HAKKIMIZDA
                        </Link>
                        <Link 
                          to="/iletisim" 
                          className="transition-all duration-300 font-medium text-lg text-red-600 hover:text-red-600 px-4 py-2 rounded-lg bg-red-50"
                          onClick={closeMobileMenu}
                        >
                          İLETİŞİM
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>

              <div className="min-h-screen bg-gray-50 text-black py-16 pt-32">
                <div className="container mx-auto px-4 sm:px-6">
                  <div className="text-center mb-16">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-8 px-4" data-aos="fade-up">İletişim</h1>
                    
                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8" data-aos="fade-up" data-aos-delay="100">
                      <a 
                        href="tel:05445625656" 
                        className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105"
                      >
                        Hemen Ara
                      </a>
                      <a 
                        href="mailto:n56otomotiv@hotmail.com" 
                        className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300"
                      >
                        E-posta Gönder
                      </a>
                    </div>
                  </div>
                  
                  {/* Shop Images Gallery */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16 max-w-6xl mx-auto">
                    <div className="relative group">
                      <img 
                        src={shopImage1} 
                        alt="N56 OTOLASTİK Dükkan Görünümü 1" 
                        className="w-full h-64 object-cover rounded-lg shadow-lg group-hover:shadow-xl transition-shadow duration-300"
                      />
                      <div className="absolute inset-0 bg-black bg-opacity-20 rounded-lg group-hover:bg-opacity-10 transition-opacity duration-300"></div>
                    </div>
                    <div className="relative group">
                      <img 
                        src={shopImage2} 
                        alt="N56 OTOLASTİK Dükkan Görünümü 2" 
                        className="w-full h-64 object-cover rounded-lg shadow-lg group-hover:shadow-xl transition-shadow duration-300"
                      />
                      <div className="absolute inset-0 bg-black bg-opacity-20 rounded-lg group-hover:bg-opacity-10 transition-opacity duration-300"></div>
                    </div>
                  </div>
                  
                  {/* Contact Information - Full Width */}
                  <div className="bg-white p-8 rounded-lg shadow-lg max-w-6xl mx-auto">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                      
                      {/* Left Side - Contact Details */}
                      <div>
                        <h3 className="text-2xl font-bold text-red-600 mb-6">N56 OTOLASTİK</h3>
                        <div className="space-y-6 text-gray-700">
                          <div className="flex items-start space-x-4">
                            <div className="w-6 h-6 text-red-600 mt-1">📍</div>
                            <div>
                              <p className="font-semibold text-lg">Adres</p>
                              <p className="text-gray-600">Afet evleri mahallesi Kurtalan yolu üzeri 1. km no 154</p>
                              <p className="text-gray-600">Merkez / Siirt, Türkiye</p>
                            </div>
                          </div>
                          <div className="flex items-start space-x-4">
                            <div className="w-6 h-6 text-red-600 mt-1">📞</div>
                            <div>
                              <p className="font-semibold text-lg">Telefon</p>
                              <a href="tel:05445625656" className="text-xl font-semibold text-gray-800 hover:text-red-600 transition-colors duration-300">
                                0544 56 256 56
                              </a>
                            </div>
                          </div>
                          <div className="flex items-start space-x-4">
                            <div className="w-6 h-6 text-red-600 mt-1">✉️</div>
                            <div>
                              <p className="font-semibold text-lg">E-posta</p>
                              <p className="text-gray-600">n56otomotiv@hotmail.com</p>
                              <p className="text-gray-600">n56otomotiv@gmail.com</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right Side - Working Hours */}
                      <div>
                        <h3 className="text-2xl font-bold text-gray-800 mb-6">Çalışma Saatleri</h3>
                        <div className="space-y-4 text-gray-700 mb-8">
                          <div className="flex items-center space-x-4">
                            <div className="w-6 h-6 text-red-600">🕒</div>
                            <div>
                              <p className="font-semibold">Pazartesi - Cuma</p>
                              <p className="text-gray-600">08:30 - 18:30</p>
                            </div>
                          </div>
                          <div className="flex items-center space-x-4">
                            <div className="w-6 h-6 text-red-600">🕒</div>
                            <div>
                              <p className="font-semibold">Cumartesi</p>
                              <p className="text-gray-600">08:30 - 17:30</p>
                            </div>
                          </div>
                          <div className="flex items-center space-x-4">
                            <div className="w-6 h-6 text-red-600">🕒</div>
                            <div>
                              <p className="font-semibold">Pazar</p>
                              <p className="text-gray-600">Kapalı</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Bottom Section - Call to Action */}
                    <div className="mt-12 pt-8 border-t border-gray-200 text-center">
                      <p className="text-lg text-gray-600">
                        Uzman ekibimizle aracınızın lastik ihtiyaçlarını karşılayın
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          } />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
